import { render, staticRenderFns } from "./ToggleUserModal.vue?vue&type=template&id=605e5633"
import script from "./ToggleUserModal.vue?vue&type=script&lang=js"
export * from "./ToggleUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports